// Tartı Senkronu penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'inventory.scaleSync';

export const inventoryScaleSyncGuide = (t: TFunction): GuideContent => ({
  layout: 'split',
  title: t(`${G}.title`, 'Tartı senkronu nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bu pencere, birimi kg olan ürünlerinizi barkodlu tartılara gönderir. Solda GTS\'teki kg ürünleri, sağda tartının hafızasındaki kayıtlar yan yana görünür; böylece neyin gönderildiğini ve cihazda ne olduğunu görerek çalışırsınız.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve tartılar'),
    list: t(`${G}.regions.list`, 'GTS kg ürünleri'),
    form: t(`${G}.regions.form`, 'Cihazdaki kayıtlar'),
    footer: t(`${G}.regions.footer`, 'Durum ve gönderim'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Tartıları seçin'),
      text: t(`${G}.s1.text`, '"Tartılar:" satırında aktif tartılar listelenir ve hepsi seçili gelir. Bir tartının üzerine tıklayarak seçimden çıkarabilir ya da geri ekleyebilirsiniz. Gönderim ve okuma yalnız seçili tartılara yapılır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tanımlı tartı yoksa önce Cihaz Yönetimi › Tartılar ekranından ekleyin.'),
      ],
    },
    {
      region: 'list',
      title: t(`${G}.s2.title`, '2. Tartı kodu olmayan ürünlere kod verin'),
      text: t(`${G}.s2.text`, 'Listede yalnız birimi kg olan aktif ürünler görünür. Tartı kodu olmayan ürünlerde kod "yok" yazar ve durum "Kod yok" olur; bunlar tartıya gönderilemez. "n ürüne kod ver" düğmesi bu ürünlere 1\'den başlayarak boştaki en küçük numarayı atar.'),
      tips: [
        t(`${G}.s2.tip1`, 'Tartı kodu, ağırlık barkodunun ortasına basılan koddur; kasa ürünü bu kodla bulur.'),
      ],
    },
    {
      region: 'header',
      title: t(`${G}.s3.title`, '3. Cihazları okuyun'),
      text: t(`${G}.s3.text`, '"Tara: 1 –" kutusuna kaçıncı PLU\'ya kadar okunacağını yazın (en fazla 1000) ve "Cihazları Oku"ya basın. Okuma yapılmadan hangi ürünün tartıda güncel olduğu bilinemez; durumlar "Okunmadı" görünür.'),
    },
    {
      region: 'list',
      title: t(`${G}.s4.title`, '4. Eşleşme durumunu kontrol edin'),
      text: t(`${G}.s4.text`, 'Okumadan sonra her ürünün durumu görünür. Eşleştirme tartı koduna göre yapılır; tartıya KDV dahil satış fiyatı gönderilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Güncel: ad, fiyat ve raf ömrü cihazdakiyle aynı.'),
        t(`${G}.s4.tip2`, 'Farklı: fiyat, ad veya raf ömrü farklı; altında neyin farklı olduğu yazar. Ad karşılaştırmasında ilk 40 karakter esas alınır.'),
        t(`${G}.s4.tip3`, 'Cihazda yok: ürün seçili tartı(lar)da bulunmuyor.'),
      ],
    },
    {
      region: 'form',
      title: t(`${G}.s5.title`, '5. Cihazdaki fazla kayıtları silin'),
      text: t(`${G}.s5.text`, '"Cihazdaki kayıtlar" panelinde tartının hafızası görünür (birden çok tartı seçiliyse her tartı ayrı sekmededir). "GTS\'te yok" etiketli kayıtların GTS\'te karşılığı yoktur; kasada yanlış fiyat okunmaması için temizlenmelidir. Satırdaki çöp kutusu tek kaydı, uyarıdaki "Hepsini sil" bu kayıtların tümünü siler.'),
      tips: [
        t(`${G}.s5.tip1`, 'Silme işlemi cihazdan kayıt kaldırır ve geri alınamaz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Tartıya gönderin'),
      text: t(`${G}.s6.text`, '"Farklı olanları gönder" yalnız "Farklı" ve "Cihazda yok" ürünleri gönderir (önce cihazları okumanız gerekir). Ana düğme ise listede işaretlediğiniz ürünleri seçili tüm tartılara gönderir. Gönderimden sonra doğrulamak için cihazları yeniden okuyun.'),
      tips: [
        t(`${G}.s6.tip1`, 'Ürün cihazda zaten varsa kendi PLU numarasının üzerine yazılır, böylece aynı ürünün iki kaydı oluşmaz; yoksa PLU numarası olarak tartı kodu kullanılır.'),
        t(`${G}.s6.tip2`, 'Alt satırda kg ürün sayısı, seçili ürün sayısı ve güncel olmayan ürün sayısı görünür.'),
      ],
    },
  ],
});
